import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bool, func } from 'prop-types';
// import { useLocation } from 'react-router';
import copy from 'copy-to-clipboard';

import { loadGhostPages } from '../../redux/reducers/ghost'

const mapStateToProps = (state) => ({
  sdkPostLoaded: state.ghost.sdkPostLoaded
});

const mapDispatchToProps = {
  loadGhostPages
};

ApiListener.propTypes = {
  loadGhostPages: func,
  sdkPostLoaded: bool
};

function ApiListener(props) {
  const { loadGhostPages, sdkPostLoaded } = props;
  // const location = useLocation();

  useEffect(() => {
    loadGhostPages();
  }, []);

  useEffect(() => {
    const copyBtns = document.querySelectorAll('.clipboard');
    if (sdkPostLoaded && copyBtns.length !== 0) {
      copyBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          copy(btn.nextSibling.textContent);
        });
      });
    }
  }, [sdkPostLoaded]);

  return null;
}


export default connect(mapStateToProps, mapDispatchToProps)(ApiListener);
